export default (str: number) => {
    if (str === 0) return '0 Bytes'
    const k = 1024
    const dm = 2
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(str) / Math.log(k))
    return parseFloat((str / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
